<div class="flex gap-2">
  <app-pan-button color="danger" icon="delete" (click)="params.deleteCallback(params.data)" matTooltip="Remove Terminal"></app-pan-button>
</div>
